/** The RBP Shopping List page. A `ProtectedRoute`: it spans the five RBP depots, so it needs no
 *  ordering choice. */
export const RBP_SHOPPING_LIST_ROUTE = '/rbp';
